import React, { useState, useEffect, Fragment } from "react";
import { Link } from 'react-router-dom';
import CardMembers from "./card_news";
import Loader from '../common/loaderapp';
// import { link } from "fs";

const Members = () => {
    const [miembros, setMembers] = useState([])
    const [actualizar, setActualizar] = useState(false)
    const [load, setLoad] = useState(true)

    const [region, setRegion] = useState({
        id_mem:0,
        id_rm: '',
        name: '',
        link:''
    });

    const [newregion, setNewregion] = useState({
        id_rm: '',
        name: '',
        link:''
    });

    const actnewregion=(e)=>setNewregion({ ...newregion, [e.target.name]:(e.target.value)})

    const actregion=(e)=>setRegion({ ...region, [e.target.name]:(e.target.value)})

    useEffect(() => {
        fetch('/rt_obtener_members', { headers: { 'Content-Type': 'application/json' } })
            .then(res => res.json())
            .then(res => {
                console.log(res.result);
                setMembers(res.result)
                setActualizar(false)
                setLoad(false)
            })
            .catch(err => console.log('Error:', err))
    }, [actualizar]);

    const agregarNuevoMiembro=()=>{
        fetch('/rt_members', { 
            headers: { 'Content-Type': 'application/json' }, 
            method: 'POST',
            body: JSON.stringify(newregion) 
        })
        .then(res => res.json())
        .then(res => {
            console.log(res);
            setActualizar(!actualizar)
            setNewregion({
                id_rm: '',
                name: '',
                link:''
            })
        })
        .catch(err => console.log('Error:', err))
    }

    const actualizarMiembro=()=>{
        fetch('/rt_members', { 
            headers: { 'Content-Type': 'application/json' }, 
            method: 'PUT',
            body: JSON.stringify(region) 
        })
        .then(res => res.json())
        .then(res => {
            console.log(res);
            setActualizar(!actualizar)
            setRegion({
                id_mem:0,
                id_rm: '',
                name: '',
                link:''
            })
        })
        .catch(err => console.log('Error:', err))
    }

    const borrarMiembro=(id)=>{
        console.log('Clickkk borrar',id);
        
        fetch('/rt_members', { 
            headers: { 'Content-Type': 'application/json' }, 
            method: 'DELETE',
            body: JSON.stringify({id}) 
        })
        .then(res => res.json())
        .then(res => {
            console.log(res);
            setActualizar(!actualizar)
        })
        .catch(err => console.log('Error:', err))
    }

    return (
        <Fragment>
            {load ?
                <Loader /> :
                <Fragment>
                    <div className="col-sm-12 mt-5 mb-5">
                        <div className="row">
                            <div className="col-sm-12 mb-2 mt-3"></div>
                        </div>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <h5>Members</h5>
                                <p>You can edit the name, photo and title, also you can add members or delete them.</p>
                            </div>
                        </div>
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <form className="row" action="#">
                                    <div className="form-group col-md-4 mb-3">
                                        <label>Region:</label>
                                        <select className="form-control form-select" name="id_rm" value={newregion.id_rm} onChange={actnewregion}>
                                            <option selected>Select region</option>
                                            <option value="1">AMERICAS Region</option>
                                            <option value="2">EMEAS Region</option>
                                            <option value="3">ASIA PACIFIC Region</option>
                                            <option value="4">AFFILIATE MEMBERS</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-4 mb-3">
                                        <label>Company name:</label>
                                        <input className="form-control" name="name" type="text" value={newregion.name} onChange={actnewregion}></input>
                                    </div>
                                    <div className="form-group col-md-4 mb-3">
                                        <label>Link:</label>
                                        <input className="form-control" name="link" type="text" value={newregion.link} onChange={actnewregion}></input>
                                    </div>
                                    <div className="col-12 mb-4 d-flex justify-content-end">

                                        <button className="btnAddSpeaker btnOrange" onClick={(event)=>{event.preventDefault();agregarNuevoMiembro()}}>Add Member</button>

                                    </div>
                                </form>

                            </div>
                            <div className="col-md-12">
                                <div className="card mt-2">
                                    <div className="table-responsive prueba">
                                        <table className="table table-sticky v2">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        Region
                                                    </th>
                                                    <th scope="col">
                                                        Company name
                                                    </th>
                                                    <th scope="col">
                                                        Link
                                                    </th>
                                                    <th scope="col">
                                                        Edit
                                                    </th>
                                                    <th scope="col">
                                                        Delete
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    miembros.map((miembro, i) =>
                                                        <tr>
                                                            <td>
                                                                {miembro.NAME_RM}
                                                            </td>
                                                            <td>
                                                                {miembro.NAME_MEM}
                                                            </td>
                                                            <td>
                                                                {miembro.LINK_MEM}
                                                            </td>
                                                            <td>
                                                                <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal" 
                                                                    onClick={()=>{setRegion({
                                                                        id_mem: miembro.ID_MEM,
                                                                        id_rm: miembro.ID_RM,
                                                                        name: miembro.NAME_MEM,
                                                                        link: miembro.LINK_MEM
                                                                    })}}>
                                                                <i class="fa-solid fa-pen-to-square"></i> Edit
                                                                </button>
                                                            </td>
                                                            <td><button type="button" class="btn btn-danger" onClick={()=>{borrarMiembro(miembro.ID_MEM)}}><i class="fa-solid fa-trash"></i> Delete</button></td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Company name</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <form className="row">
                                    <div className="form-group col-12 mb-3">
                                        <label>Region:</label>
                                        <select className="form-control form-select" name="id_rm" value={region.id_rm} onChange={actregion}>
                                            <option selected>Select region</option>
                                            <option value="1">AMERICAS Region</option>
                                            <option value="2">EMEAS Region</option>
                                            <option value="3">ASIA PACIFIC Region</option>
                                            <option value="4">AFFILIATE MEMBERS</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-12 mb-3">
                                        <label>Company names:</label>
                                        <input className="form-control" name="name" type="text" value={region.name} onChange={actregion}></input>
                                    </div>
                                    <div className="form-group col-12 mb-3">
                                        <label>Link:</label>
                                        <input className="form-control" name="link" type="text" value={region.link} onChange={actregion}></input>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary" onClick={actualizarMiembro}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
                </Fragment >
            }
        </Fragment>
    );
}
export default Members;